import styled from '@emotion/styled';

const StyledNavigationPlaceholder = styled.div`
	height: 48px;
`;

export function NavigationPlaceholder() {
	return (
		<StyledNavigationPlaceholder>
			<span>&nbsp;</span>
		</StyledNavigationPlaceholder>
	);
}
